import * as angular from 'angular';
import { IOperationStatisticModel, OperationMessageResult, OperationMessageStatus } from '../../models';

class OperationStatusComponent implements ng.IComponentController {
    public cssClass: string;
    public hint: string;

    private operation: IOperationStatisticModel;

    public $onInit() {
        switch (this.operation.Status) {
            case OperationMessageStatus.Enqueued:
                this.cssClass = 'icon-time opacity54';
                this.hint = 'Pending';
                return;
            case OperationMessageStatus.Processing:
                this.cssClass = 'icon-processing opacity54';
                this.hint = 'Processing';
                return;
        }

        switch (this.operation.Result) {
            case OperationMessageResult.Error:
                this.cssClass = 'icon-error-rounded--red';
                this.hint = 'Error';
                return;
            case OperationMessageResult.Warning:
                this.cssClass = 'icon-warning-rounded--red';
                this.hint = 'Warning';
                return;
            case OperationMessageResult.Success:
                this.cssClass = 'icon-check-rounded--green';
                this.hint = 'Success';
                return;
        }

    }
}

angular
    .module('naut')
    .component('operationStatus', {
        controller: OperationStatusComponent,
        bindings: {
            operation: '<',
            showHint: '<'
        },
        template: '<i class="icon24 inline-block {{::$ctrl.cssClass}}" title="{{$ctrl.hint}}"></i>&nbsp;<span ng-show="$ctrl.showHint">{{::$ctrl.hint}}</span>'
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/inventory/components/operation-list/operation-status.component.ts